import {
    Component,
    OnInit,
    ChangeDetectionStrategy,
    OnDestroy,
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BusinessOwnerService } from 'src/app/acl-data/business-owner/business-owner.service';
import { map, switchMap } from 'rxjs/operators';
import { of, Observable, BehaviorSubject } from 'rxjs';
import { BusinessOwner } from 'src/app/acl-data/business-owner/business-owner.dto';
import { SubSink } from 'subsink';
import { deepCopy } from 'src/app/acl-data/general/generic.function';

@Component({
    templateUrl: './business-owner-edit.component.html',
    styleUrls: ['./business-owner-edit.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BusinessOwnerEditComponent implements OnDestroy {
    error$ = new BehaviorSubject<any>(undefined);
    sink = new SubSink();

    businessOwnerID$ = this.route.paramMap.pipe(
        map(v => v.get('businessOwnerID'))
    );

    businessOwner;

    businessOwner$ = this.businessOwnerID$.pipe(
        switchMap(v => {
            if (v === 'AddNew') {
                return of({});
            } else {
                return this.businessOwnerService.getByKey(v);
            }
        })
    ) as Observable<BusinessOwner>;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private businessOwnerService: BusinessOwnerService
    ) {
        this.sink.add(
            this.businessOwner$.subscribe(
                v => (this.businessOwner = deepCopy(v))
            )
        );
    }
    ngOnDestroy(): void {
        this.sink.unsubscribe();
    }

    delete = input => {
        console.log('Deleting');
        this.businessOwnerService.delete(input).subscribe(v => {
            console.log('Delete completed');
            this.router.navigate(['..'], {
                relativeTo: this.route,
            });
        });
    };

    save = input => {
        console.log('Saving', input);
        if (!!input.id) {
            this.businessOwnerService.update(input).subscribe(
                v => {
                    console.log('Save completed');
                    this.router.navigate(['..'], {
                        relativeTo: this.route,
                    });
                },
                e => {
                    this.businessOwner = deepCopy(input);
                    this.error$.next(e);
                }
            );
        } else {
            this.businessOwnerService.add(input).subscribe(
                v => {
                    console.log('Add completed');
                    this.router.navigate(['..'], {
                        relativeTo: this.route,
                    });
                },
                e => this.error$.next(e)
            );
        }
    };
}
